import {
  Module, VuexModule, Mutation, Action,
} from 'vuex-module-decorators';
import API from '@/lib/API';
import { User } from '@/types';

@Module
export default class Users extends VuexModule {
  data: User[] = []

  get users(): User[] {
    return this.data;
  }

  @Mutation
  setUsers({ users }: { users: User[] }) {
    console.log('mutations:setUsers'); // eslint-disable-line no-console

    const data: User[] = [];

    users.forEach((doc) => {
      data.push({
        id: doc.id,
        name: doc.name,
        groups: doc.groups,

        isSuperUser: doc.isSuperUser,
        isDisabled: doc.isDisabled,
        isVirtual: doc.isVirtual,

        iCalToken: doc.iCalToken,
      });
    });

    this.data = data;

    return Promise.resolve();
  }

  @Action({ rawError: true })
  async initUsers() {
    console.log('actions:initUsers'); // eslint-disable-line no-console

    return this.context.dispatch('updateUsers');
  }

  @Action({ rawError: true })
  async updateUsers() {
    console.log('actions:updateUsers'); // eslint-disable-line no-console

    let users: User[] = [];
    try {
      users = await API.getUsers({ permissions: false });
    } catch (error) {
      return Promise.reject(error);
    }

    return this.context.commit('setUsers', {
      users: users && Array.isArray(users) && users.length > 0 ? users : [],
    });
  }
}
